module.exports = __webpack_public_path__ + "static/media/img_jardin_familiar.d45ec8f5.png";